import { AllowedConnectorTypes } from '../config/allowed-connector-types';
import { NodeTypes } from '../config/node-types';

const searchData = AllowedConnectorTypes.map((type) => ({
  type,
  title: NodeTypes[type].title,
  node: 'connector',
})).sort((a, b) => a.title.localeCompare(b.title));

// searchData = [
//   ...searchData,
//   ...AllowedStatementTypes.map((type) => ({
//     type,
//     title: NodeTypes[type].title,
//     node: "statement",
//   })),
// ];

// searchData = [
//   ...searchData,
//   ...AllowedTaskTypes.map((type) => {
//     console.log(NodeTypes[type], type);
//     return {
//       type,
//       title: NodeTypes[type].title,
//       node: "task",
//     };
//   }),
// ];

searchData.sort((a, b) => a.title.localeCompare(b.title));
export default searchData;
